import React, { useEffect } from 'react';
import { YMaps } from '@pbe/react-yandex-maps';
import { CartProvider } from 'features';
import { ModalProvider } from 'shared';
import { LoadAppDataProcess } from 'processes';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { YMInitializer } from 'react-yandex-metrika';
import { HelmetProvider } from 'react-helmet-async';
import { withRedux } from './store/store-provider';
// import { useAppDispath } from './store/store-hooks';
// import APP_ACTIONS from '../controllers/app/app-actions';
// import '../styles/index.scss';
// import AppLoadingPreview from '../components/app-loading-preview';
// import { useAppState } from '../controllers/app/app-hooks';
import AppRouterProvider from './router/app-router-provider';
import { ChakraProvider } from './providers/chakra-provider';

const App = () => {
    useEffect(() => {
        if (window.navigator.webdriver) {
            document.dispatchEvent(
                new Event('prerender-ready'),
            );
        }
    }, []);
    return (
        <AppRouterProvider />
    );
};

export default withRedux(
    <ChakraProvider>
        <HelmetProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <YMaps>
                    <YMInitializer
                        accounts={[32151944]}
                        options={{
                            webvisor: true, trackHash: true, clickmap: true, ecommerce: 'dataLayer', referrer: document.referrer, accurateTrackBounce: true, trackLinks: true,
                        }}
                    />
                    <CartProvider>
                        <ModalProvider>
                            <LoadAppDataProcess>
                                <App />
                            </LoadAppDataProcess>
                        </ModalProvider>
                    </CartProvider>
                </YMaps>
            </LocalizationProvider>
        </HelmetProvider>
    </ChakraProvider>,
);
